import React, { Component } from 'react';
import HeaderComponent from '../headers/HeaderComponent';
import {Link} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './home.scss';

class HomeComponent extends Component{

	constructor(props){
		super(props);

		this.state = {
			authTypeSend: null
		}
	}
 
	render(){
		return (
			<React.Fragment>
			<div className="intro-wrapper">
			<div className="hp-container pd-top-global">
				{/*<HeaderComponent handleSignupFromHome={this.handleSignupFromHeader}/>*/}
				<div className="home-wrapper">
				<HeaderComponent showHeader = {true}/>
					<div className="row">
					<div className="col-xs-12 col-sm-6 hp-container-mobile">
						<div className="home-intro-wrapper">
							<div className="home-head">
								Hyperpure Logistic Admin
							</div>
							<div className="home-para">
								Admin for Logistic management
							</div>
							<div className="btn-wrapper">
								<Link to="auth">
									<div className="btn btn-green">
										Go to Admin &nbsp;<FontAwesomeIcon className="home-btn-icon" icon="chevron-circle-right"/>
									</div>
								</Link>
							</div>
							
						</div>
	
					</div>
					
					
					</div>

				</div>
			</div>
	
			</div>
			</React.Fragment>
		)
	}
}

export default HomeComponent;
